import type { Financial } from "epsm-api-types/models";
import { fiscalPeriodsGrouped } from "../../../config";
import type { FinancialWithPeriod, FiscalPeriod } from "../../../types";

export const getSortedFinancialsData = (
	data: Financial[],
	fiscalPeriod: FiscalPeriod,
): FinancialWithPeriod[] => {
	if (!data.length || !fiscalPeriod || !fiscalPeriodsGrouped[fiscalPeriod])
		return [];

	const fiscalPeriodOrder = fiscalPeriodsGrouped[fiscalPeriod];

	return data
		.map((item) => ({
			...item,
			period: `${item.fiscal_period}-${item.fiscal_year.toString().slice(2)}`,
		}))
		.toSorted((a, b) => {
			const yearA = a.fiscal_year;
			const yearB = b.fiscal_year;
			const periodA = a.fiscal_period;
			const periodB = b.fiscal_period;

			if (yearA !== yearB) {
				return yearB - yearA;
			}

			const indexA = fiscalPeriodOrder.indexOf(periodA);
			const indexB = fiscalPeriodOrder.indexOf(periodB);

			return indexA - indexB;
		});
};
